import { render, staticRenderFns } from "./BannerIcon.vue?vue&type=template&id=beb28afe&"
import script from "./BannerIcon.vue?vue&type=script&lang=js&"
export * from "./BannerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports